function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.392115 21.7124C-0.738636 23.717 0.744447 26 2.69693 26H17.3031C19.2556 26 20.7386 23.717 19.6079 21.7124C17.6807 18.2958 14.0995 16 10 16C5.90048 16 2.31928 18.2958 0.392115 21.7124Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15 9C15 11.7614 12.7614 14 10 14C7.23858 14 5 11.7614 5 9C5 6.23858 7.23858 4 10 4C12.7614 4 15 6.23858 15 9Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M17 9C17 8.44772 17.4477 8 18 8H27C27.5523 8 28 8.44772 28 9C28 9.55228 27.5523 10 27 10H18C17.4477 10 17 9.55228 17 9Z",
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M17 12C17 11.4477 17.4477 11 18 11H25C25.5523 11 26 11.4477 26 12C26 12.5523 25.5523 13 25 13H18C17.4477 13 17 12.5523 17 12Z",
  fill: "currentColor"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M19 6C19 5.44772 19.4477 5 20 5H27C27.5523 5 28 5.44772 28 6C28 6.55228 27.5523 7 27 7H20C19.4477 7 19 6.55228 19 6Z",
  fill: "currentColor"
});

var SvgAbout = function SvgAbout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAbout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/About.9ba45ee4.svg";
export { ForwardRef as ReactComponent };